var _excluded = ["Component", "validate"];
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { Fragment } from 'react';
import { Field, FieldArray } from 'formik';
import Text from './Text';
import Input from './Input';
import Select from './Select';
import InternationalPhone from './InternationalPhone';
import Autosuggest from './Autosuggest';
import { isRequired, hasSelection } from './utils';
var validateField = function validateField(value, check, _ref) {
  var required = _ref.required;
  return check && check(value) || required && isRequired(value);
};
function FormField(_ref2) {
  var Component = _ref2.Component,
    _validate = _ref2.validate,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(Field, _extends({
    validate: function validate(value) {
      return validateField(value, _validate, props);
    }
  }, props), function (_ref3) {
    var field = _ref3.field,
      _ref3$form = _ref3.form,
      errors = _ref3$form.errors,
      touched = _ref3$form.touched,
      values = _ref3$form.values;
    return /*#__PURE__*/React.createElement(Component, _extends({
      error: touched[field.name] && errors[field.name],
      checked: values[field.name] === props.value // needed only for inputs
    }, field, props));
  });
}
export function TextField(props) {
  return /*#__PURE__*/React.createElement(FormField, _extends({
    Component: Text
  }, props));
}
export function SelectField(props) {
  return /*#__PURE__*/React.createElement(FormField, _extends({
    Component: Select
  }, props));
}
export function InputField(props) {
  return /*#__PURE__*/React.createElement(FormField, _extends({
    Component: Input
  }, props));
}
export function InternationalPhoneField(props) {
  return /*#__PURE__*/React.createElement(FormField, _extends({
    Component: InternationalPhone
  }, props));
}
export function AutosuggestField(props) {
  return /*#__PURE__*/React.createElement(FormField, _extends({
    Component: Autosuggest
  }, props));
}
export function CheckboxGroupField(_ref4) {
  var name = _ref4.name,
    required = _ref4.required,
    title = _ref4.title,
    options = _ref4.options,
    disabled = _ref4.disabled;
  return /*#__PURE__*/React.createElement(FieldArray, {
    name: name
  }, function (_ref5) {
    var _ref5$form = _ref5.form,
      values = _ref5$form.values,
      setFieldValue = _ref5$form.setFieldValue;
    var selected = values[name] || [];
    return /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement("legend", {
      className: "".concat(required ? 'cb-required ' : '').concat(disabled ? 'cb-text-disabled' : '')
    }, title), options.map(function (opt, i) {
      var isChecked = selected.find(function (v) {
        return v == opt.value;
      });
      var optLength = options.length;
      return /*#__PURE__*/React.createElement(Fragment, {
        key: opt.value
      }, /*#__PURE__*/React.createElement(InputField, {
        validate: function validate() {
          return required && hasSelection(selected);
        },
        name: name,
        value: opt.value,
        label: opt.label,
        checked: isChecked,
        disabled: disabled,
        onChange: function onChange(e) {
          var checked = e.target.checked;
          var isSingleSelect = options.find(function (o) {
            return o.value == opt.value && o.singleSelect;
          });
          if (!checked) setFieldValue(name, selected.filter(function (s) {
            return s !== opt.value;
          }));else if (isSingleSelect) setFieldValue(name, [opt.value]);else setFieldValue(name, [opt.value].concat(_toConsumableArray(selected.filter(function (s) {
            return !options.find(function (o) {
              return o.value == s && o.singleSelect;
            });
          }))));
        }
      }), i < optLength - 1 ? /*#__PURE__*/React.createElement("div", {
        className: "cb-spacerv-16"
      }) : null);
    }));
  });
}